import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { IoIosClose } from "react-icons/io";
import { BsPersonFill } from "react-icons/bs";
import { useAppContext } from "context/Context";
const LeftSidebar = () => {
  const { toggleSidebar, setToggleSidebar } = useAppContext();
  return (
    <Container
      toggle={toggleSidebar}
      className="flex-1 bg-gray-900 overflow-x-hidden overflow-y-auto "
    >
      <div className="flex md:hidden justify-end items-center my-2 mr-2 ">
        {" "}
        <span
          onClick={() => {
            setToggleSidebar(false);
          }}
          className="text-gray-200 text-2xl font-bold p-2 rounded-lg hover:bg-gray-500 cursor-pointer"
        >
          <IoIosClose />
        </span>
      </div>
      <ul>
        {/* first one is for avatar */}
        <li>
          <div className="flex justify-start items-center  p-2 m-2 rounded-lg group hover:bg-gray-600 cursor-pointer">
            <span className="mr-2  text-3xl text-blue-500  group-hover:text-blue-400">
              <BsPersonFill />
            </span>
            <span className="text-gray-500 text-base font-medium  group-hover:text-gray-400">
              Jhon Wick
            </span>
          </div>
        </li>
        {navlistItems?.map((item, index) => (
          <li key={index}>
            <div className="flex justify-start items-center  p-2 m-2 rounded-lg group hover:bg-gray-600 cursor-pointer">
              <span className="mr-2  text-3xl text-blue-500  group-hover:text-blue-400">
                {item?.icon}
              </span>
              <span className="text-gray-500 text-base font-medium  group-hover:text-gray-400">
                {item?.name}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </Container>
  );
};

export default LeftSidebar;

const Container = styled.div`
  height: calc(100vh - 80px);
  position: sticky;
  top: 80px;
  margin-left: 0%;
  z-index: 100;
  transition: all 0.3s ease-in-out;

  @media (max-width: 768px) {
    margin-left: ${(props) => (props.toggle ? "0%" : "-78%")};
    position: fixed;
    top: 0;
    height: 100vh;
    min-width: 250px;
  }
  ${tw``}
`;

const navlistItems = [
  { name: "Friends", icon: <BsPersonFill /> },
  { name: "Saved", icon: <BsPersonFill /> },
  { name: "Groups", icon: <BsPersonFill /> },
  { name: "market Place", icon: <BsPersonFill /> },
  { name: "Watch", icon: <BsPersonFill /> },
];
